/* Analytics viz extras: heatmap cards, similarity matrix, empty states.
   Colors use design tokens so dark mode works automatically. */

.heatmap-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--md-sys-spacing-lg);
}

.heatmap-card {
  display: flex;
  flex-direction: column;
  gap: var(--md-sys-spacing-sm);
}

.heatmap-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--md-sys-color-on-surface);
}

.heatmap-caption {
  font-size: 0.9rem;
  color: var(--md-sys-color-on-surface-variant);
  text-align: center;
}

.heatmap-wrap {
  position: relative;
  display: flex;
  justify-content: center;
}

.heatmap-canvas {
  max-width: 100%;
  border-radius: var(--md-sys-shape-corner-small);
  background-color: var(--md-sys-color-surface-container-low);
}

/* Similarity matrix */
.similarity-matrix {
  overflow-x: auto;
}

.similarity-matrix table {
  border-collapse: collapse;
  width: 100%;
  font-size: 0.8rem;
}

.similarity-matrix th,
.similarity-matrix td {
  border: 1px solid var(--md-sys-color-outline-variant);
  padding: 6px 8px;
  text-align: center;
  white-space: nowrap;
}

.similarity-matrix th {
  background-color: var(--md-sys-color-surface-container);
}

.similarity-matrix td {
  font-weight: 400;
}

.similarity-matrix td.similarity-cell-medium,
.similarity-matrix td.similarity-cell-strong {
  font-weight: 700;
}

.similarity-matrix td.similarity-cell {
  background-color: transparent;
}

.similarity-matrix td.similarity-cell-soft {
  background-color: rgba(26, 111, 196, 0.15);
}

.similarity-matrix td.similarity-cell-medium {
  background-color: rgba(26, 111, 196, 0.3);
}

.similarity-matrix td.similarity-cell-strong {
  background-color: rgba(26, 111, 196, 0.45);
}

/* Empty states */
.analysis-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--md-sys-spacing-sm);
  padding: var(--md-sys-spacing-xl);
  color: var(--md-sys-color-on-surface-variant);
}

.analysis-empty-icon {
  font-size: 42px;
  opacity: 0.6;
}
